import type React from 'react';
import type { BonanzaPromoDataApi, BonanzaPromoImageByStatus } from '@/api/cms';
import { ImageComponent } from '@/components/Image';
import { ScContainer } from '@/styles/common';
import { Heading } from './Heading';
import { PromoStatus } from './PromoStatus';
import { ScTopSection } from './styled';

interface ITopSectionProps {
  data: BonanzaPromoDataApi;
  bgByStatus?: BonanzaPromoImageByStatus;
}

export const TopSection: React.FC<ITopSectionProps> = ({
  data,
  bgByStatus,
}) => (
  <ScTopSection>
    <ImageComponent
      alt="bonanza bg"
      className="bg"
      fill
      loading="eager"
      priority
      src={bgByStatus?.image?.url || data?.bg?.url || ''}
    />
    <ScContainer>
      <Heading
        congratulations={data.congratulations}
        description={data.description}
        enjoyYourPlay={data.enjoyYourPlay}
        pageTitle={data.pageTitle}
        title={data.title}
        titleImg={data.titleImg}
      />
      <PromoStatus bonanzaStatus={data.bonanzaStatus} />
    </ScContainer>
  </ScTopSection>
);
